import { render, staticRenderFns } from "./HistoryChanges.vue?vue&type=template&id=65264240&"
import script from "./HistoryChanges.vue?vue&type=script&lang=js&"
export * from "./HistoryChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports